"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataUi = exports.DataUIGroups = void 0;
const constants_1 = require("./constants");
var DataUIGroups;
(function (DataUIGroups) {
    DataUIGroups["form"] = "form";
    DataUIGroups["table"] = "table";
})(DataUIGroups = exports.DataUIGroups || (exports.DataUIGroups = {}));
function mergeLayoutConfigs(configs) {
    if (configs.length === 1) {
        return configs[0];
    }
    const config = {};
    for (const c of configs) {
        for (const group of Object.values(DataUIGroups)) {
            if (c[group]) {
                config[group] = { ...config[group], ...c[group] };
            }
        }
    }
    return config;
}
var DataUi;
(function (DataUi) {
    function Name(nameOrConfig) {
        return (target) => {
            if (typeof nameOrConfig === 'string') {
                nameOrConfig = { name: nameOrConfig };
            }
            Reflect.defineMetadata(constants_1.DATA_UI_NAME_METADATA, nameOrConfig, target);
        };
    }
    DataUi.Name = Name;
    function Permissions(permissions) {
        return (target) => {
            if (permissions.constructor !== Object) {
                const permissionsList = (Array.isArray(permissions) ? permissions : [permissions]);
                permissions = {
                    read: permissionsList,
                    write: permissionsList,
                };
            }
            Reflect.defineMetadata(constants_1.DATA_UI_PERMISSIONS_METADATA, permissions, target);
        };
    }
    DataUi.Permissions = Permissions;
    function DefaultLayoutConfig(...configs) {
        return (target) => {
            Reflect.defineMetadata(constants_1.DATA_UI_LAYOUT_CONFIG_METADATA, mergeLayoutConfigs(configs), target);
        };
    }
    DataUi.DefaultLayoutConfig = DefaultLayoutConfig;
    function LayoutConfig(...configs) {
        return (target, propertyKey) => {
            Reflect.defineMetadata(constants_1.DATA_UI_LAYOUT_CONFIG_METADATA, mergeLayoutConfigs(configs), target.constructor, propertyKey);
        };
    }
    DataUi.LayoutConfig = LayoutConfig;
    function SearchField(config = { default: true }) {
        return (target, propertyKey) => {
            Reflect.defineMetadata(constants_1.DATA_UI_SEARCH_CONFIG_METADATA, config, target.constructor, propertyKey);
        };
    }
    DataUi.SearchField = SearchField;
    function EnumValues(values) {
        return (target, propertyKey) => {
            if (!Array.isArray(values)) {
                Reflect.defineMetadata(constants_1.DATA_UI_ENUM_VALUES_WITH_KEYS_METADATA, values, target.constructor, propertyKey);
                values = Object.values(values);
            }
            Reflect.defineMetadata(constants_1.DATA_UI_ENUM_VALUES_METADATA, values, target.constructor, propertyKey);
        };
    }
    DataUi.EnumValues = EnumValues;
    function EnumValuesFromPicklist(picklistName, multiple, defaultValue) {
        return (target, propertyKey) => {
            Reflect.defineMetadata(constants_1.DATA_UI_ENUM_VALUES_FROM_PICKLIST_METADATA, { picklistName, multiple, defaultValue }, target.constructor, propertyKey);
        };
    }
    DataUi.EnumValuesFromPicklist = EnumValuesFromPicklist;
    function Override(overrides) {
        return (target, propertyKey) => {
            Reflect.defineMetadata(constants_1.DATA_UI_TEXT_LENGTH_METADATA, overrides, target.constructor, propertyKey);
        };
    }
    DataUi.Override = Override;
    function S3File(config) {
        const { name, arrayMode = 'replace', fullUrl = false } = config;
        return (target, propertyKey) => {
            Reflect.defineMetadata(constants_1.DATA_UI_S3FILE_CONFIG_METADATA, { name, arrayMode, fullUrl }, target.constructor, propertyKey);
        };
    }
    DataUi.S3File = S3File;
    function Actions(actions) {
        return (target) => {
            Reflect.defineMetadata(constants_1.DATA_UI_ADDITIONAL_ACTION, actions, target);
        };
    }
    DataUi.Actions = Actions;
    function Description(text) {
        return (target, propertyKey) => {
            Reflect.defineMetadata(constants_1.DATA_UI_DESCRIPTION_METADATA, text, propertyKey ? target.constructor : target, propertyKey);
        };
    }
    DataUi.Description = Description;
})(DataUi = exports.DataUi || (exports.DataUi = {}));
//# sourceMappingURL=decorators.js.map